var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "form-container form-group-material form-group-material-no-label position-relative fe-dp w-auto",
    },
    [
      _c("vue-timepicker", {
        staticClass: "text-gray",
        attrs: {
          id: _vm.id,
          value: _vm.localValue,
          "input-class": "material-input form-control p-0",
          format: _vm.formatToShow["12h"],
          "hide-clear-button": _vm.hideClearButton,
          "drop-direction": _vm.dropDirection,
          disabled: _vm.disabled,
        },
        on: { change: _vm.handleChange },
      }),
      _vm._v(" "),
      _vm.label
        ? _c(
            "label",
            { class: { "d-none": _vm.hiddenLabel }, attrs: { for: _vm.id } },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "bar" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }